"use client"

import { useState, useEffect, useCallback } from "react"
import { scrollToSection } from "@/lib/scroll-to-section"

export function Header() {
  const [isGlitching, setIsGlitching] = useState(false)

  const triggerGlitch = useCallback(() => {
    setIsGlitching(true)
    const timer = setTimeout(() => setIsGlitching(false), 300)
    return () => clearTimeout(timer)
  }, [])

  useEffect(() => {
    const glitchInterval = setInterval(triggerGlitch, 8000)
    return () => clearInterval(glitchInterval)
  }, [triggerGlitch])

  return (
    <header 
      className="fixed top-0 left-0 right-0 z-50 glass-cyber-strong border-b border-[#B829FF]/50"
      style={{ contain: "layout style paint" }}
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <button
          type="button"
          onClick={() => scrollToSection("home")}
          className={`text-xl md:text-2xl font-black font-[family-name:var(--font-orbitron)] tracking-wider bg-gradient-to-r from-[#B829FF] via-[#00A3FF] to-[#FFEA00] bg-clip-text text-transparent ${isGlitching ? "animate-glitch" : ""}`}
          style={{ willChange: "transform" }}
          aria-label="Ir para o início"
        >
          NITROX STORE
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {[
            { label: "Home", id: "home" },
            { label: "Serviços", id: "services" },
            { label: "Produtos", id: "products" },
            { label: "Contato", id: "contact" },
          ].map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => scrollToSection(item.id)}
              className="relative text-slate-100/90 hover:text-[#00F0FF] transition-colors duration-300 font-medium group"
            >
              {item.label}
              <span className="absolute -bottom-1 left-0 w-0 h-[2px] bg-gradient-to-r from-[#00F0FF] to-[#B829FF] group-hover:w-full transition-all duration-300" />
            </button>
          ))}
        </nav>

        <div className="hidden md:block w-[190px]" aria-hidden="true" />
      </div>
    </header>
  )
}
